// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"60557363","331":"55c254c3","819":"7642bd05"}[chunkId] + ".chunk.js";
};